"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOgBetProvider = void 0;
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const injectors_1 = require("og-core/store/injectors");
const react_1 = require("react");
const storage_1 = require("../../utils/storage");
const constants_1 = require("../../utils/storage/constants");
const react_redux_1 = require("react-redux");
const BetsProvider_1 = require("astra-core/containers/BetsProvider");
function useOgBetProvider() {
    // eslint-disable-next-line
    // @ts-expect-error
    (0, injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.ogBetProviderSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        const isActive = (0, storage_1.getLocalStorageItem)(constants_1.StorageKeys.isQuickBetActive, false);
        dispatch(BetsProvider_1.betsProviderActions.setQuickBetActive({ isActive }));
    }, [dispatch]);
}
exports.useOgBetProvider = useOgBetProvider;
//# sourceMappingURL=useOgBetProvider.js.map